/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type bambooDuplicates_viewer$ref = any;
export type bambooDuplicates_QueryVariables = {||};
export type bambooDuplicates_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: bambooDuplicates_viewer$ref,
  |}
|};
export type bambooDuplicates_Query = {|
  variables: bambooDuplicates_QueryVariables,
  response: bambooDuplicates_QueryResponse,
|};
*/


/*
query bambooDuplicates_Query {
  viewer {
    actualPersonId
    component(name: "control_bamboo_duplicates")
    ...bambooDuplicates_viewer
    id
  }
}

fragment bambooDuplicates_viewer on Viewer {
  id
  missionControlData {
    id
    bambooDuplicates {
      id
      company
      duplicateCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "control_bamboo_duplicates"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"control_bamboo_duplicates\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "bambooDuplicates_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "bambooDuplicates_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "bambooDuplicates_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlBambooDuplicatesType",
                "kind": "LinkedField",
                "name": "bambooDuplicates",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "company",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duplicateCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "bambooDuplicates_Query",
    "operationKind": "query",
    "text": "query bambooDuplicates_Query {\n  viewer {\n    actualPersonId\n    component(name: \"control_bamboo_duplicates\")\n    ...bambooDuplicates_viewer\n    id\n  }\n}\n\nfragment bambooDuplicates_viewer on Viewer {\n  id\n  missionControlData {\n    id\n    bambooDuplicates {\n      id\n      company\n      duplicateCount\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a35feeb0697a06ac4cbe8673deca6702';

module.exports = node;
